import React, { Suspense } from "react";
import Loader from "./components/Loader/Loader";
import Test from "./pages/Test/Test";
import EditforMySelf from "./pages/AdvertiseDetail/EditForMyself";
import MySubscription from "./pages/MySubscription/MySubscription.jsx";
import CreateFile from "./pages/CreateFile/CreateFile.jsx";
// import AdvertiseDetail from "./pages/AdvertiseDetail/DetailOrder";

// const DefaultPage = React.lazy(() =>
//   import("./pages/DefaultPage/Default Page")
// );
const Support = React.lazy(() => import("./pages/Support/Support.jsx"))
const Tutorials = React.lazy(() => import("./pages/Tutorials/Tutorials.jsx"))
const SingleTutorial = React.lazy(() => import("./pages/Tutorials/SingleTutorial.jsx"))
const LoginStepOne = React.lazy(() => import("./pages/login/LoginStepOne"));
const LoginStepThird = React.lazy(() => import("./pages/login/LoginStepThird"));
const LoginStepTwo = React.lazy(() => import("./pages/login/LoginStepTwo"));
const ChoosLocationPage = React.lazy(() =>
    import("./pages/RegisterAD/ChoosLocationPage")
);
const TermsAndConditions = React.lazy(() =>
    import("./pages/TermsAndConditions/TermsAndConditions")
);
const CategoryView = React.lazy(() => import("./pages/Category/Category"));
const SplashView = React.lazy(() => import("./pages/Splash/Splash"));
const AdsOnMap = React.lazy(() => import("./pages/AdsOnMap/AdsOnMap"));
const Wallet = React.lazy(() => import("./pages/Wallet/Wallet"));
const Houses = React.lazy(() => import("./pages/Houses/Houses"));
const RegisterAD = React.lazy(() => import("./pages/RegisterAD/RegisterAD"));
// const BuySubscription = React.lazy(() => import("./pages/BuySubscription/BuySubscription"));
// const BuyArchieveFilingSubscription = React.lazy(() => import("./pages/BuyArchieveFilingSubscription/BuyArchieveFilingSubscription"));
const BuyFilingSubscription = React.lazy(() => import("./pages/BuyFilingSubscription/BuyFilingSubscription"));
const WalletAndScores = React.lazy(() => import("./pages/WalletAndScores/WalletAndScores"));
const MySubscriptions = React.lazy(() => import("./pages/MySubscriptions/MySubscriptions"));
const EditProfileBusiness = React.lazy(() =>
    import("./pages/EditProfileBusiness/EditProfileBusiness")
);
const NonProperty = React.lazy(() =>
    import("./pages/NonProperty/NonProperty")
);
const CurrencyPage = React.lazy(() =>
    import("./pages/CurrencyPage/CurrencyPage")
);
const RentalAd = React.lazy(() => import("./pages/RentalAd/RentalAd"));
const Planner = React.lazy(() => import("./pages/Planner/PLanner"));
const Call = React.lazy(() => import("./pages/Call/Call"));
const Rewards = React.lazy(() => import("./pages/Rewards/Rewards"));
const Instagram = React.lazy(() => import("./pages/Rewards/Instagram"));
const CooperativeAd = React.lazy(() => import("./pages/Rewards/CooperativeAd"));
const ReportAd = React.lazy(() => import("./pages/Rewards/ReportAd"));
const InviteAdFriends = React.lazy(() => import("./pages/Rewards/InviteAdFriends"));

const NotificationsPage = React.lazy(() =>
    import("./pages/NotificationsPage/NotificationsPage")
);

const FollowPage = React.lazy(() => import("./pages/FollowPage/FollowPage"));

const Messages = React.lazy(() => import("./pages/Messages/connect/Messages"));
const EditProfile = React.lazy(() => import("./pages/EditProfile/EditProfile"));
const Auctions = React.lazy(() => import("./pages/Auctions/Auctions"));
const AboutView = React.lazy(() => import("./pages/AboutView/AboutView"));
const InstallPelak = React.lazy(() => import("./pages/InstallPelak/InstallPelak"));
const FollowersPage = React.lazy(() =>
    import("./pages/FollowersPage/FollowersPage")
);
const FollowingsPage = React.lazy(() =>
    import("./pages/FollowingsPage/FollowingsPage")
);
const Shown = React.lazy(() => import("./pages/shown/shown"));

const Profile = React.lazy(() =>
    import("./pages/Profile/Profile")
);
const MyAds = React.lazy(() =>
    import("./pages/Profile/MyAds")
);
const ProgramSettings = React.lazy(() =>
    import("./pages/ProgramSettings/ProgramSettings")
);

const PaymentResult = React.lazy(() => 
    import("./pages/Payment/PaymentResult")
)

const BlackList = React.lazy(() => import("./pages/BlackList/BlackList"));
const SelectAds = React.lazy(() => import("./pages/SelectAds/SelectAds"));
const HelpVeeu = React.lazy(() => import("./pages/HelpVeeu/HelpVeeu"));
const ChatPage = React.lazy(() => import("./pages/Chat/ChatPage"));
const AdvertiseDetail = React.lazy(() => import("./pages/AdvertiseDetail/AdvertiseDetail"));
const LoginLocation = React.lazy(() => import("./pages/login/LoginLocation"));
const AdManagement = React.lazy(() => import("./pages/Home/AdManagement"));

const Lawyers = React.lazy(() =>
    import("./pages/Lawyers/Lawyers")
)
const LawyersCategoryFiles = React.lazy(() =>
    import("./pages/Lawyers/LawyersCategoryFiles")
);
const LawyersFileDetail = React.lazy(() =>
    import("./pages/Lawyers/LawyersFileDetail")
);
const LawyersConsultationForm = React.lazy(() =>
    import("./pages/Lawyers/LawyersConsultationForm.jsx")
)

const Edit = React.lazy(() => import("./pages/Home/edit"));
const EditAds = React.lazy(() => import("./pages/Home/EditAds"));
const AllADSs = React.lazy(() => import("./pages/AllADSs/AllADSs"));
const PickCategory = React.lazy(() => import("./pages/AllADSs/PickCategory"));
const PelakSupport = React.lazy(() => import("./pages/PelakSupport/PelakSupport"));
const CalculateCommission = React.lazy(() =>
    import("./pages/CalculateCommission/CalculateCommission")
);
const Blogs = React.lazy(() =>
    import("./pages/Blogs/Blogs")
);

const Blog = React.lazy(() =>
    import("./pages/Blog/Blog")
);

const Constructors = React.lazy(() => import("./pages/Constructors/Constructors.jsx"))
const ConstructorsList = React.lazy(() => import("./pages/Constructors/ConstructorsList.jsx"))
// allADSs is home page

let routes = [
    {
        path: "/SplashView",
        element: (
            <Suspense fallback={<Loader />}>
                <SplashView />
            </Suspense>
        ),
    },
    // {
    //   path: "/AllADS",
    //   element: (
    //     <Suspense fallback={<Loader />}>
    //       <DefaultPage />
    //     </Suspense>
    //   ),
    // },
    {
        path: "/*",
        element: (
            <Suspense fallback={<Loader />}>
                <AllADSs />
            </Suspense>
        ),
    },
    {
        path: "/Tutorials",
        element: (
            <Suspense fallback={<Loader />}>
                <Tutorials />
            </Suspense>
        ),
    },
    {
        path: "/PaymentResult",
        element: (
            <Suspense fallback={<Loader />}>
                <PaymentResult />
            </Suspense>
        ),
    },
    {
        path: "/Tutorial/:fileName",
        element: (
            <Suspense fallback={<Loader />}>
                <SingleTutorial />
            </Suspense>
        ),
    },
    {
        path: "/PickCategory/*",
        element: (
            <Suspense fallback={<Loader />}>
                <PickCategory />
            </Suspense>
        ),
    },
    {
        path: "/Blog/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <Blog />
            </Suspense>
        ),
    },
    {
        path: "/Support",
        element: (
            <Suspense fallback={<Loader />}>
                <Support />
            </Suspense>
        ),
    },
    {
        path: "/Lawyers",
        element: (
            <Suspense fallback={<Loader />}>
                <Lawyers />
            </Suspense>
        ),
    },
    {
        path: "/Lawyers/Category/:categoryId",
        element: (
            <Suspense fallback={<Loader />}>
                <LawyersCategoryFiles />
            </Suspense>
        ),
    },
    {
        path: "/Lawyers/File/:fileId",
        element: (
            <Suspense fallback={<Loader />}>
                <LawyersFileDetail />
            </Suspense>
        ),
    },
    {
        path: "/Lawyers/Consultation/:categoryId",
        element: (
            <Suspense fallback={<Loader />}>
                <LawyersConsultationForm />
            </Suspense>
        ),
    },
    {
        path: "/Blogs",
        element: (
            <Suspense fallback={<Loader />}>
                <Blogs />
            </Suspense>
        ),
    },
    {
        path: "/CommissionCalculate",
        element: (
            <Suspense fallback={<Loader />}>
                <CalculateCommission />
            </Suspense>
        ),
    },
    {
        path: "/AdvertiseDetail/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <AdvertiseDetail />
            </Suspense>
        ),
    },
    {
        path: "/EditforMySelf/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <EditforMySelf />
            </Suspense>
        ),
    },
    {
        path: "/EditAds/",
        element: (
            <Suspense fallback={<Loader />}>
                <EditAds />
            </Suspense>
        ),
    },

    {
        path: "/LoginLocation",
        element: (
            <Suspense fallback={<Loader />}>
                <LoginLocation />
            </Suspense>
        ),
    },

    {
        path: "/AdsOnMap",
        element: (
            <Suspense fallback={<Loader />}>
                <AdsOnMap />
            </Suspense>
        ),
    },
    {
        path: "/Wallet",
        element: (
            <Suspense fallback={<Loader />}>
                <Wallet />
            </Suspense>
        ),
    },
    {
        path: "/property",
        element: (
            <Suspense fallback={<Loader />}>
                <Houses />
            </Suspense>
        ),
    },
    {
        path: "/property/:adsPrptyTypeCode",
        element: (
            <Suspense fallback={<Loader />}>
                <Houses />
            </Suspense>
        ),
    },
    {
        path: "/property/:adsPrptyTradeTypeCode/:adsPrptyTypeCode",
        element: (
            <Suspense fallback={<Loader />}>
                <Houses />
            </Suspense>
        ),
    },
    {
        path: "/RegisterAD",
        element: (
            <Suspense fallback={<Loader />}>
                <RegisterAD />
            </Suspense>
        ),
    },
    {
        path: "/EditProfileBusiness",
        element: (
            <Suspense fallback={<Loader />}>
                <EditProfileBusiness />
            </Suspense>
        ),
    },
    // const nonPropertyGetUrl = {"buildingMaterials" : 3 , "metals":2 , "services-labor":6 , "communal" : 5 , "machine-tools" : 4 , "architect-contractor":7 }
    {
        path: "buildingMaterials",
        element: (
            <Suspense fallback={<Loader />}>
                <NonProperty />
            </Suspense>
        ),
    },
    {
        path: "metals",
        element: (
            <Suspense fallback={<Loader />}>
                <NonProperty />
            </Suspense>
        ),
    },
    {
        path: "services-labor",
        element: (
            <Suspense fallback={<Loader />}>
                <NonProperty />
            </Suspense>
        ),
    },
    {
        path: "communal",
        element: (
            <Suspense fallback={<Loader />}>
                <NonProperty />
            </Suspense>
        ),
    },
    {
        path: "machine-tools",
        element: (
            <Suspense fallback={<Loader />}>
                <NonProperty />
            </Suspense>
        ),
    },
    {
        path: "architect-contractor",
        element: (
            <Suspense fallback={<Loader />}>
                <NonProperty />
            </Suspense>
        ),
    },
    {
        path: "/CurrenciesPage",
        element: (
            <Suspense fallback={<Loader />}>
                <CurrencyPage />
            </Suspense>
        ),
    },
    { path: "/RentalAd/:id", element: <Suspense fallback={<Loader />}><RentalAd /></Suspense> },
    {
        path: "/Planner",
        element: (
            <Suspense fallback={<Loader />}>
                <Planner />
            </Suspense>
        ),
    },
    {
        path: "/Call",
        element: (
            <Suspense fallback={<Loader />}>
                <Call />
            </Suspense>
        ),
    },

    {
        path: "/NotificationsPage",
        element: (
            <Suspense fallback={<Loader />}>
                <NotificationsPage />
            </Suspense>
        ),
    },
    {
        path: "/FollowPage/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <FollowPage />
            </Suspense>
        ),
    },
    {
        path: "/Messages",
        element: (
            <Suspense fallback={<Loader />}>
                <Messages />
            </Suspense>
        ),
    },
    {
        path: "/EditProfile",
        element: (
            <Suspense fallback={<Loader />}>
                <EditProfile />
            </Suspense>
        ),
    },
    {
        path: "/Auctions",
        element: (
            <Suspense fallback={<Loader />}>
                <Auctions />
            </Suspense>
        ),
    },
    {
        path: "/Shown",
        element: (
            <Suspense fallback={<Loader />}>
                <Shown />
            </Suspense>
        ),
    },
    {
        path: "/AboutPelakeMan",
        element: (
            <Suspense fallback={<Loader />}>
                <AboutView />
            </Suspense>
        ),
    },
    {
        path: "/InstallPelak",
        element: (
            <Suspense fallback={<Loader />}>
                <InstallPelak />
            </Suspense>
        ),
    },
    {
        path: "/FollowersPage/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <FollowersPage />
            </Suspense>
        ),
    },
    {
        path: "/FollowingsPage/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <FollowingsPage />
            </Suspense>
        ),
    },
    {
        path: "/Profile",
        element: (
            <Suspense fallback={<Loader />}>
                <Profile />
            </Suspense>
        ),
    },
    {
        path: "/Profile/MyAds",
        element: (
            <Suspense fallback={<Loader />}>
                <MyAds />
            </Suspense>
        ),
    },
    {
        path: "/ProgramSettings",
        element: (
            <Suspense fallback={<Loader />}>
                <ProgramSettings />
            </Suspense>
        ),
    },

    {
        path: "/ChoosLocationPage",
        element: (
            <Suspense fallback={<Loader />}>
                <ChoosLocationPage />
            </Suspense>
        ),
    },
    {
        path: "/TermsAndConditions",
        element: (
            <Suspense fallback={<Loader />}>
                <TermsAndConditions />
            </Suspense>
        ),
    },
    {
        path: "/CategoryView",
        element: (
            <Suspense fallback={<Loader />}>
                <CategoryView />
            </Suspense>
        ),
    },
    {
        path: "/SplashView",
        element: (
            <Suspense fallback={<Loader />}>
                <SplashView />
            </Suspense>
        ),
    },
    {
        path: "/invitaion",
        element: (
            <Suspense fallback={<Loader />}>
                <LoginStepThird />
            </Suspense>
        ),
    },
    {
        path: "/LoginSecondStep",
        element: (
            <Suspense fallback={<Loader />}>
                <LoginStepTwo />
            </Suspense>
        ),
    },
    {
        path: "/LoginStepOne",
        element: (
            <Suspense fallback={<Loader />}>
                <LoginStepOne />
            </Suspense>
        ),
    },
    {
        path: "/BlackList",
        element: (
            <Suspense fallback={<Loader />}>
                <BlackList />
            </Suspense>
        ),
    },
    {
        path: "/SelectAds",
        element: (
            <Suspense fallback={<Loader />}>
                <SelectAds />
            </Suspense>
        ),
    },
    {
        path: "/PelakHelp",
        element: (
            <Suspense fallback={<Loader />}>
                <HelpVeeu />
            </Suspense>
        ),
    },
    {
        path: "/PelakSupport",
        element: (
            <Suspense fallback={<Loader />}>
                <PelakSupport />
            </Suspense>
        ),
    },
    {
        path: "/ChatPage/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <ChatPage />
            </Suspense>
        ),
    },
    {
        path: "/AdManagement",
        element: (
            <Suspense fallback={<Loader />}>
                <AdManagement />
            </Suspense>
        ),
    },
    {
        path: "/Edit/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <Edit />
            </Suspense>
        ),
    },
    {
        path: "/WalletAndScores",
        element: (
            <Suspense fallback={<Loader />}>
                <WalletAndScores />
            </Suspense>
        ),
    },
    {
        path: "/MySubscriptions",
        element: (
            <Suspense fallback={<Loader />}>
                <MySubscriptions />
            </Suspense>
        ),
    },
    // {
    //   path: "/BuySubscription",
    //   element: (
    //     <Suspense fallback={<Loader />}>
    //       <BuySubscription />
    //     </Suspense>
    //   ),
    //   children: [
    //     {
    //       path: "BuyFilingSubscription", // Nested route
    //       element: (
    //         <Suspense fallback={<Loader />}>
    //           <BuyFilingSubscription />
    //         </Suspense>
    //       ),
    //     },
    //     {
    //       path: "BuyArchieveFilingSubscription", // Nested route
    //       element: (
    //         <Suspense fallback={<Loader />}>
    //           <BuyArchieveFilingSubscription />
    //         </Suspense>
    //       ),
    //     },
    //   ],
    // },

    {
        path: "/BuyFilingSubscription",
        element: (
            <Suspense fallback={<Loader />}>
                <BuyFilingSubscription />
            </Suspense>
        ),
    },
    {
        path: "/Rewards",
        element: (
            <Suspense fallback={<Loader />}>
                <Rewards />
            </Suspense>
        ),
    },
    {
        path: "/Rewards/Instagram",
        element: (
            <Suspense fallback={<Loader />}>
                <Instagram />
            </Suspense>
        ),
    },
    {
        path: "/Rewards/CooperativeAd",
        element: (
            <Suspense fallback={<Loader />}>
                <CooperativeAd />
            </Suspense>
        ),
    },
    {
        path: "/Rewards/ReportAd",
        element: (
            <Suspense fallback={<Loader />}>
                <ReportAd />
            </Suspense>
        ),
    },
    {
        path: "/Rewards/InviteAdFriends",
        element: (
            <Suspense fallback={<Loader />}>
                <InviteAdFriends />
            </Suspense>
        ),
    },
    {
        path: "/Test",
        element: (
            <Suspense fallback={<Loader />}>
                <Test />
            </Suspense>
        ),
    },
    {
        path: "/Constuctors",
        element: (
            <Suspense fallback={<Loader />}>
                <Constructors />
            </Suspense>
        )
    },
    {
        path: "/ConstructorsList",
        element: (
            <Suspense fallback={<Loader />}>
                <ConstructorsList />
            </Suspense>
        )
    },
    {
        path: "/MySubscription",
        element: (
            <Suspense fallback={<Loader />}>
                <MySubscription />
            </Suspense>
        )
    },
    {
        path: "/CreateFile",
        element: (
            <Suspense fallback={<Loader />}>
                <CreateFile />
            </Suspense>
        )
    }
];

export default routes;
